export default __webpack_public_path__ + "static/media/forms_icon.2c8d8455.svg";